import { render, staticRenderFns } from "./AspediaCRMGrid.vue?vue&type=template&id=4570ac0a&scoped=true"
import script from "./AspediaCRMGrid.vue?vue&type=script&lang=js"
export * from "./AspediaCRMGrid.vue?vue&type=script&lang=js"
import style0 from "./AspediaCRMGrid.vue?vue&type=style&index=0&id=4570ac0a&prod&lang=scss&scoped=true"
import style1 from "./AspediaCRMGrid.vue?vue&type=style&index=1&id=4570ac0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4570ac0a",
  null
  
)

export default component.exports